const comments = [
  {
    name: '吃瓜不嫌事大',
    time: '2小时前',
    content: '这个平台真的太绝了！每天都要刷好几遍，更新速度比微博还快。上次那个顶流出轨的料，别家还在转二手消息的时候你们已经把时间线都整理好了，这才是专业吃瓜该有的样子！',
    likes: '2.3万',
    avatar: 'ri-user-smile-line',
  },
  {
    name: '娱乐圈观察员老张',
    time: '5小时前',
    content: '作为关注娱乐圈二十年的老观众，我必须说吃瓜黑料爆料是目前信息最全、最有深度的娱乐追踪平台。不只是简单转载，每篇解析都看得出编辑做了功课。建议增加一个"谣言粉碎"栏目，专门扒那些假瓜。',
    likes: '1.8万',
    avatar: 'ri-user-star-line',
  },
  {
    name: '深夜吃瓜人',
    time: '8小时前',
    content: '匿名投稿这个机制做得太好了！之前我手里有个挺大的料一直不敢爆，就是怕被查出来。看到这个平台对爆料人的保护措施之后才下定决心投稿，结果第二天就上了热搜，太爽了！',
    likes: '1.5万',
    avatar: 'ri-moon-line',
  },
  {
    name: '理性吃瓜代表',
    time: '12小时前',
    content: '希望平台能继续保持客观中立的态度。现在很多娱乐号为了流量什么都敢编，吃瓜黑料爆料至少每条爆料都会标注信息来源和可信度，这一点真的很难得。证据整理的功能特别好用，一目了然。',
    likes: '9.8千',
    avatar: 'ri-user-heart-line',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="scroll-mt-20 py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            瓜友热评
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            来看看吃瓜群众们都在讨论什么
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6 max-w-5xl mx-auto">
          {comments.map((c, i) => (
            <div key={i} className="bg-background-100 rounded-lg p-5">
              <div className="flex items-center gap-3 mb-4">
                <span className="w-10 h-10 flex items-center justify-center bg-primary-100 text-primary-600 rounded-full">
                  <i className={`${c.avatar} text-lg`}></i>
                </span>
                <div>
                  <p className="text-sm font-semibold text-foreground-800">{c.name}</p>
                  <p className="text-xs text-foreground-400">{c.time}</p>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                {c.content}
              </p>
              <div className="flex items-center gap-4 text-xs text-foreground-400">
                <span className="flex items-center gap-1 cursor-pointer hover:text-primary-500 transition-colors">
                  <i className="ri-thumb-up-line"></i> {c.likes}
                </span>
                <span className="flex items-center gap-1 cursor-pointer hover:text-primary-500 transition-colors">
                  <i className="ri-chat-1-line"></i> 回复
                </span>
                <span className="flex items-center gap-1 cursor-pointer hover:text-primary-500 transition-colors">
                  <i className="ri-share-forward-line"></i> 分享
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}